import React from 'react'
import styles from './styles'
import { withStyles, Typography } from '@material-ui/core'
import data from './data'
import { CoreButton } from 'src/components/core'
import { exportCourseToScormAction } from 'src/reducers/course/action'
import { useDispatch, useSelector } from 'react-redux'
import UserType from 'src/model/user-types'

const ScormView = props => {
  const { classes, me } = props
  const dispatch = useDispatch()

  const entity = useSelector(state => state.course.course)
  const handleDownload = type => {
    dispatch(
      exportCourseToScormAction(entity.name, entity.id, type, response => {}),
    )
  }
  const userControl = !(
    UserType[me.userRoleId] === 'Premium Plus' ||
    UserType[me.userRoleId] === 'Premium Plus v2' ||
    UserType[me.userRoleId] === 'Elite' ||
    UserType[me.userRoleId] === 'AppSumo (Tier 3)' ||
    UserType[me.userRoleId] === 'AppSumo (Tier 3A)' ||
    UserType[me.userRoleId] === 'AppSumo (Tier 4)' ||
    UserType[me.userRoleId] === 'AppSumo (Tier 5)' ||
    UserType[me.userRoleId] === 'AppSumo (Tier 6)' ||
    UserType[me.userRoleId] === 'AppSumo (Tier 7)'
  )

  return (
    <div className={classes.customDomain__root}>
      {userControl ? (
        <>
          <Typography fontSize="14px" fontWeight={400}>
            You can download the SCORM package that is compatible with your LMS.
          </Typography>
          <img src={'/assets/Upgrade.png'} alt="rocket!" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Typography fontSize="16px" fontWeight={500}>
              Upgrade to Elite Plan
            </Typography>
            <div className={classes.badge}>
              <Typography
                fontSize={'11px'}
                fontWeight={500}
                style={{ color: '#9747FF' }}
              >
                Elite
              </Typography>
            </div>
          </div>
          <Typography fontSize="14px" fontWeight={400}>
            Upgrade to the Elite Plan to export your courses to SCORM and access
            exclusive features.
          </Typography>
          <CoreButton
            fullWidth
            onClick={() => {
              window.location.href = '/pricing'
            }}
          >
            Upgrade to the Elite
          </CoreButton>
        </>
      ) : (
        <>
          <Typography className={classes.embedInstructionText}>
            You can download the SCORM package that is compatible with your LMS.
          </Typography>
          {data.map((item, index) => (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                padding: '12px',
                alignItems: 'center',
                backgroundColor: '#F4F6F8',
                borderRadius: '12px',
                cursor: 'pointer',
                gap: '8px',
              }}
              onClick={() => handleDownload(item.type)}
            >
              <img src="/assets/csv.svg" width={36} height={36} />
              <Typography fontSize={'15px'} fontWeight={500}>
                {item.title}
              </Typography>
              <div
                style={{
                  flexGrow: 1,
                }}
              />
              <CoreButton variant="contained" color="primary">
                Download
              </CoreButton>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(ScormView)
